import React from 'react';
import { LoadingSpinnerProps } from '../types';

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  color = 'currentColor',
  className = '',
  text
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  if (text) {
    return (
      <div className={`flex flex-col items-center space-y-2 ${className}`}>
        <div 
          className={`animate-spin rounded-full border-2 border-transparent border-t-current ${sizeClasses[size]}`}
          style={{ borderTopColor: color }}
          aria-label="Loading"
        >
          <span className="sr-only">Loading...</span>
        </div>
        <p className="text-sm text-gray-600">{text}</p>
      </div>
    );
  }

  return (
    <div 
      className={`animate-spin rounded-full border-2 border-transparent border-t-current ${sizeClasses[size]} ${className}`}
      style={{ borderTopColor: color }}
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default LoadingSpinner;